import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/FormModal";
import NotificationForm from "./NotificationForm";

const AddSelfTherapy = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Add_Notification_Modal, Loader } = faqProps;
  const [form] = Form.useForm();

  return (
    <FormModal
      addButtonName="Add New"
      modalTitle="Add Notification"
      submitButtonText="Save"
      cancelButtonText="Cancel"
      apiMethod="POST"
      addApiName="addNotification"
      addApiRequest="AddRecord"
      apiLoader="StartSpinner"
      ModalName="Add_Notification_Modal"
      confirmLoading={Loader}
      ModalType="Hide_Modal"
      visible={Add_Notification_Modal ? Add_Notification_Modal : false}
      width={500}
      form={form}
      recordName="notificationList"
    >
      <NotificationForm />
    </FormModal>
  );
};

export default AddSelfTherapy;
